import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { initial } from 'lodash';

type Size = 'tiny' | 'smaller' | 'small' | 'big';
type Color = 'pi-white';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoaderComponent implements OnInit {
  @Input() size!: Size;
  @Input() color!: Color;
  @Input() type: string = '';
  @Input() width: any = initial;
  @Input() height: any = initial;
  @Input() strokeWidth: string = '5';

  ngOnInit(): void {}
}
